import Tabs, { Tab, TabPanel } from '@ingka/tabs';
import { withOptimizely } from 'Components/Optimizely/Optimizely';
import CONFIG from 'Config/settings';
import PropTypes from 'prop-types';
import React from 'react';
import { t } from 'Utils/localization/i18next';
import DynamicFormRead from '../_form_extended/DynamicFormRead/DynamicFormRead';
import './AccountSettingsTabs.scss';

const tabsHashMapping = {
  'tab-button-account': '#profile',
  'tab-button-address': '#address',
  'tab-button-login': '#login',
  'tab-button-preferences': '#preferences',
  'tab-button-payments': '#payments'
};

const hashTabsMapping = {
  '#profile': 'tab-button-account',
  '#address': 'tab-button-address',
  '#login': 'tab-button-login',
  '#preferences': 'tab-button-preferences',
  '#payments': 'tab-button-payments'
};

const AccountSettingsTabs = props => {
  const decision = props.decide('profile_consent_boost');
  const sendOptimizelyEvent = event => {
    if (decision?.enabled) {
      props.trackEvent(event);
    }
  };

  const tabs = [
    <Tab
      key="tab-1"
      text={t(`dashboard.side_menu_tabs.account_settings.profile-details`)}
      tabPanelId="tab-button-account"
      prefix={CONFIG.APP.STYLES_PREFIX}
    />,
    <Tab
      key="tab-2"
      text={t(`dashboard.side_menu_tabs.account_settings.addresses`)}
      tabPanelId="tab-button-address"
      prefix={CONFIG.APP.STYLES_PREFIX}
    />,
    <Tab
      key="tab-3"
      text={t(`dashboard.side_menu_tabs.account_settings.login-security`)}
      tabPanelId="tab-button-login"
      prefix={CONFIG.APP.STYLES_PREFIX}
    />,
    ((props.profileType === 'regular' &&
      CONFIG.FEATURE.REGULAR_DASHBOARD.SHOW_PREFERENCES) ||
      (props.profileType === 'family' &&
        CONFIG.FEATURE.FAMILY_DASHBOARD.SHOW_PREFERENCES)) && (
      <Tab
        key="tab-4"
        text={t(`dashboard.side_menu_tabs.account_settings.communications`)}
        tabPanelId="tab-button-preferences"
        prefix={CONFIG.APP.STYLES_PREFIX}
        onClick={() => sendOptimizelyEvent('preferences_tab_clicked')}
      />
    ),
    props.profileType === 'family' &&
      CONFIG.FEATURE.FAMILY_DASHBOARD.ENABLE_PAYMENT_METHODS && (
        <Tab
          key="tab-5"
          text={t(`dashboard.side_menu_tabs.account_settings.payment-methods`)}
          tabPanelId="tab-button-payments"
          prefix={CONFIG.APP.STYLES_PREFIX}
        />
      )
  ];

  const tabPanels = [
    <TabPanel
      key="tab-1"
      tabPanelId="tab-button-account"
      prefix={CONFIG.APP.STYLES_PREFIX}
    >
      <DynamicFormRead
        formId={`${props.profileType}-dashboard-profile-details-read`}
      />
    </TabPanel>,
    <TabPanel
      key="tab-2"
      tabPanelId="tab-button-address"
      prefix={CONFIG.APP.STYLES_PREFIX}
    >
      <DynamicFormRead
        formId={`${props.profileType}-dashboard-billing-shipping-addresses-read`}
      />
    </TabPanel>,
    <TabPanel
      key="tab-3"
      tabPanelId="tab-button-login"
      prefix={CONFIG.APP.STYLES_PREFIX}
    >
      <DynamicFormRead
        formId={`${props.profileType}-dashboard-login-security`}
      />
    </TabPanel>,
    <TabPanel
      key="tab-4"
      tabPanelId="tab-button-preferences"
      prefix={CONFIG.APP.STYLES_PREFIX}
    >
      <DynamicFormRead
        formId={`${props.profileType}-dashboard-communication-preferences-read`}
      />
    </TabPanel>,
    props.profileType === 'family' &&
      CONFIG.FEATURE.FAMILY_DASHBOARD.ENABLE_PAYMENT_METHODS && (
        <TabPanel
          key="tab-5"
          tabPanelId="tab-button-payments"
          prefix={CONFIG.APP.STYLES_PREFIX}
        >
          <div id="wpl-payment-methods" />
        </TabPanel>
      )
  ];
  return (
    <React.Fragment>
      <Tabs
        tabs={tabs}
        tabPanels={tabPanels}
        defaultActiveTab={'tab-button-account'}
        activeTab={
          window.location.hash !== '' && hashTabsMapping[window.location.hash]
            ? hashTabsMapping[window.location.hash]
            : 'tab-button-account'
        }
        prefix={CONFIG.APP.STYLES_PREFIX}
        onTabChanged={tab => {
          window.location.hash = tabsHashMapping[tab];
        }}
      />
    </React.Fragment>
  );
};

AccountSettingsTabs.propTypes = {
  profileType: PropTypes.string,
  trackEvent: PropTypes.func,
  decide: PropTypes.func
};

const AccountSettingsTabsWithOptimizely = withOptimizely(AccountSettingsTabs);
export default AccountSettingsTabsWithOptimizely;
